import Keycloak from 'keycloak-js'
import { AUTH_SERVER_URL, CLIENT_ID, REALM } from './constants'

const keycloak = new Keycloak({
  url: `${AUTH_SERVER_URL}auth`,
  realm: REALM,
  clientId: CLIENT_ID,
})

const initKeycloak = (onAuthenticatedCallback: () => void): void => {
  keycloak
    .init({
      onLoad: 'check-sso',
      checkLoginIframe: false,
      pkceMethod: 'S256',
    })
    .then((authenticated: boolean) => {
      if (authenticated) {
        onAuthenticatedCallback()
      } else {
        doLogin()
      }
    })
    .catch((err) => {
      console.error(err)
    })
}

const doLogin = keycloak.login

const doLogout = keycloak.logout

const getToken = (): string | undefined => keycloak.token

const isLoggedIn = (): boolean => !!keycloak.token

const updateToken = (successCallback?: () => void): Promise<void> =>
  keycloak.updateToken(5).then(successCallback).catch(doLogin)

const getUsername = (): string | undefined =>
  keycloak.tokenParsed?.preferred_username

const getFullname = (): string =>
  (
    (keycloak.tokenParsed?.given_name ?? '') +
    ' ' +
    (keycloak.tokenParsed?.family_name ?? '')
  )?.trim()

const getSub = (): string | undefined => keycloak.tokenParsed?.sub

const getUserEmail = (): string | undefined => keycloak.tokenParsed?.email

const hasRole = (roles: string[]): boolean =>
  roles?.some((role: string) => keycloak.hasResourceRole(role))

const getLocation = (): string | undefined => keycloak.tokenParsed?.location

keycloak.onTokenExpired = (): void => {
  keycloak.updateToken(5)
}

const KeycloakService = {
  initKeycloak,
  doLogin,
  doLogout,
  isLoggedIn,
  getToken,
  updateToken,
  getUsername,
  getFullname,
  getSub,
  getUserEmail,
  hasRole,
  getLocation,
}

export default KeycloakService
